import {
  ShipmentLoadAlertUpdatePayload,
  ShipmentTransportOrderAlertUpdatePayload,
  ShipmentWaybillAlertUpdatePayload,
  ShipmentDeliveryNoteAlertUpdatePayload,
} from '../../models/shipment-common-models';
import { ShipmentListSearchCriteria } from '../models/shipment.model';
import { MatDialogRef } from '@angular/material/dialog';

export class ShipmentListLoad {
  public static readonly type = '[ShipmentList] Load';

  constructor(
    public payload: {
      searchCriteria: ShipmentListSearchCriteria;
      dialogRef?: MatDialogRef<unknown>;
    },
  ) {}
}

export class ShipmentStatisticsLoad {
  public static readonly type = '[ShipmentList] Statistics Load';

  constructor(
    public payload: {
      searchCriteria: ShipmentListSearchCriteria;
    },
  ) {}
}

export class ShipmentListInitialState {
  public static readonly type = '[ShipmentList] Set Initial State';
}

export class UpdateWaybillAlertList {
  public static readonly type = '[ShipmentList] Update Waybill Alert List';

  constructor(
    public payload: {
      shipmentWaybillAlertUpdatePayload: ShipmentWaybillAlertUpdatePayload;
      dialogRef: MatDialogRef<unknown>;
    },
  ) {}
}

export class UpdateTransportOrderAlertList {
  public static readonly type = '[ShipmentList] Update TransportOrder Alert List';

  constructor(
    public payload: {
      shipmentTransportOrderAlertUpdatePayload: ShipmentTransportOrderAlertUpdatePayload;
      dialogRef: MatDialogRef<unknown>;
    },
  ) {}
}

export class UpdateLoadAlertList {
  public static readonly type = '[ShipmentList] Update Load Alert List';

  constructor(
    public payload: {
      shipmentLoadAlertUpdatePayload: ShipmentLoadAlertUpdatePayload;
      dialogRef: MatDialogRef<unknown>;
    },
  ) {}
}
export class UpdateDeliveryNoteAlertList {
  public static readonly type = '[ShipmentList] Update Delivery Note Alert List';

  constructor(
    public payload: {
      shipmentDeliveryNoteAlertUpdatePayload: ShipmentDeliveryNoteAlertUpdatePayload;
      dialogRef: MatDialogRef<unknown>;
    },
  ) {}
}
